<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">龙虎统计</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <div v-if="longHuStatsList" class="content-8__content">
        <table class="even-color">
          <thead>
            <tr>
              <th>日期</th>
              <th v-for="column in columnKeys" :key="column.label">{{ column.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rowData in longHuStatsList" :key="`${rowData.date}`">
              <td>{{ rowData.date }}</td>
              <template v-for="column in columnKeys">
                <td :key="`tbody-${rowData.date}-${column.groupKey}-${column.longHu}`">
                  {{ rowData.countList[column.groupKey][column.longHu] }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { fieldList } from '@/utils/forWeb-Sean/longHu'
import { getCPStatistics_web } from '@/api/desktop/statistic'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import get from 'lodash.get'
export default {
  name: 'WebLongHuTongJi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      isLoading: true,
      lotteryCode: this.$route.params.lottery_code,
      longHuStatsList: null,
      selectKeys: 'hm1'
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.getLongHuStatistics(this.lotteryCode)
  },
  methods: {
    async getLongHuStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(code, 'dxdsHistory', {
        days: 30,
        rules: 'zuLongHu'
      })
      if (error) return
      this.longHuStatsList = data.map(each => this.makeUpForTableList(each))
      this.isLoading = false
    },
    makeUpForTableList(data) {
      /* 這裡為配合後端資料，須先判斷
      1. 統計資料是否為空 (為空則顯示 "-")
      2. 是否沒有這個欄位資料(沒有則顯示 "0")
      */
      const formatCountList = {}
      const isNullData = Object.keys(data.countList).length === 0
      if (isNullData) {
        for (let i = 0; i < this.columnKeys.length; i += 2) {
          formatCountList[this.columnKeys[i].groupKey] = {
            longHu_long: '-',
            longHu_hu: '-'
          }
        }
      } else {
        for (let i = 0; i < this.columnKeys.length; i += 2) {
          formatCountList[this.columnKeys[i].groupKey] = {
            longHu_long: get(data.countList, `${this.columnKeys[i].groupKey}.longHu_long`)
              ? Math.abs(data.countList[this.columnKeys[i].groupKey]['longHu_long']) : 0,
            longHu_hu: get(data.countList, `${this.columnKeys[i].groupKey}.longHu_hu`)
              ? Math.abs(data.countList[this.columnKeys[i].groupKey]['longHu_hu']) : 0
          }
        }
      }
      return {
        date: data.date,
        countList: formatCountList
      }
    }
  }
}
</script>
